import { render, staticRenderFns } from "./Inscricao.vue?vue&type=template&id=869373ce&scoped=true&lang=pug&"
import script from "./Inscricao.vue?vue&type=script&lang=js&"
export * from "./Inscricao.vue?vue&type=script&lang=js&"
import style0 from "./Inscricao.styl?vue&type=style&index=0&id=869373ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869373ce",
  null
  
)

export default component.exports